import PrivacyPolicy3 from './PrivacyPolicy3'
export default PrivacyPolicy3
